"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductsByCategoryErrors = void 0;
var UseCaseError_1 = require("../../../../models/concrete/UseCaseError");
exports.getProductsByCategoryErrors = [
    UseCaseError_1.UseCaseError.create('invalidData'),
    UseCaseError_1.UseCaseError.create('notFound'),
    UseCaseError_1.UseCaseError.create('problemInProcess')
];
//# sourceMappingURL=getProductsByCategoryErrors.js.map